import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation('common');

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="py-24 relative overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: 'url(https://static.readdy.ai/image/c07ed6529feea951012003251bff6ba4/78a627228f114a68e878a20237e5938e.jpeg)' }}></div>
      <div className="absolute inset-0 bg-black/70"></div>
      <div className="max-w-6xl mx-auto px-6 lg:px-8 relative z-10">
        {/* Image Container */}
        <div className="rounded-3xl overflow-hidden mb-16">
          <img 
            src="https://public.readdy.ai/ai/img_res/7bc9bcdd39622225fb1e00f0c600b2bb.jpg"
            alt="Modern IT Infrastructure"
            className="w-full h-full object-cover object-top"
          />
        </div>

        {/* CTA Content */}
        <div className="text-center">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-8 leading-tight max-w-4xl mx-auto">
            {t('cta.title')}
          </h2>

          {/* CTA Button - Now scrolls to contact form */}
          <button 
            onClick={scrollToContact}
            className="px-8 py-4 bg-[#4d9c71] text-white font-semibold rounded-xl hover:shadow-xl hover:shadow-[#4d9c71]/50 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            {t('cta.button')}
          </button>
        </div>
      </div>
    </section>
  );
}
